<template>
    <div class="bg_white">
        <van-nav-bar
        title="我的证件"
        left-text=""
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
        >
        <template #right>
            <van-icon name="service-o" size="20"/>
        </template>
        </van-nav-bar>



          <div class="fileImage" v-for="item in fileList" :key="item.id">
            <div class="flex fileInfo1">
              <img :src="common.getImageUrl(photo)" alt="" class="pic">
              <div class="fileInforight">
                <div class="box1">
                  <div>证号  <span>{{ item.fileNo }}</span></div>
                </div>
                <div class="box1 flex">
                  <div class="box2">姓名   <span>{{ userName }}</span></div>
                  <div class="box3 green">人员类型 <span>{{ getQulType(item.quaType) }}</span></div>
                </div>
                <div class="box1 flex">
                  <div class="box2">性别   <span>{{ gendle==1?'男':'女' }}</span></div>
                  <div class="box3 green">行业类别 <span>{{ getWorkType(item.workType) }}</span></div>
                </div>
                
              </div>
            </div>
            <div class="flex fileInfo2">
              <div class="box2">初领日期  <span>{{ item.createTime }}</span></div>
              <div class="box2">有效期限  <span>{{ item.startTime +"至"+ item.endTime}}</span></div>
              <div class="box1">签发机关  <span>福州市应急管理局</span></div>
            </div>
            
          </div>

          <!-- <van-cell title="证件号" :value="item.fileNo" />
          <van-cell title="单位类型" :value="getWorkType(item.workType)" />
          <van-cell title="资格类型" :value="getQulType(item.quaType)" />
          <van-cell title="领证时间" :value="item.createTime" />
          <van-cell title="开始时间" :value="item.startTime" />
          <van-cell title="失效时间" :value="item.endTime" /> -->
          

        

        <van-empty description="暂无数据"  v-if="fileList.length<1"/>
    </div>
</template>

<script>
import { getCustomFiles,getDictData } from '../../api/custom';
export default {
  data() {
    return {
        fileList:[],
        workTypeList:[],
        quaList:[],
        userName:"",
        photo:"",
        gendle:"",

    }

   },
   created(){
    //单位类型
    getDictData("exam_work_type").then(res => {
      this.workTypeList = res.data.list
    }),
    //资格类型
    getDictData("sys_qulification_type").then(res => {
      this.quaList = res.data.list
    }),
    getCustomFiles().then(res=>{
      console.log(res)
      if(res.success){
        this.fileList=res.data.customfile
        this.userName=res.data.userName
        this.photo=res.data.photo
        this.gendle=res.data.gendle
      }else{
        this.$dialog.alert({
                    message: res.message,
                    theme: 'round-button',
                    confirmButtonText:'确定'
         })
      }
     
    })
   },
   methods: {
     
    onClickLeft() {
      this.$router.back()
    },
    onClickRight() {
      this.$router.push("/online")
    },
    getQulType(val) {
      let result = ""
      this.quaList.forEach(item => {
        if (item.dictValue == val) {
          result = item.dictLabel
        }
      })
      return result;

    },
    getWorkType(val) {
      let result = ""
      this.workTypeList.forEach(item => {
        if (item.dictValue == val) {
          result = item.dictLabel
        }
      })
      return result;

    },
  }

};
</script>

<style lang="less">

.fileImage{
  width: 90%;
  margin: 8px auto;
  padding: 10px;
  border: 1px solid #ebedf0;
  border-radius: 6px;
  div{
    color: #333;
    font-size: 12px;
  }
  span{
    color: #000;
    font-size: 14px;
  }
  .fileInfo1{
    img{
    width: 100px;
    height: 110px;
  }
    align-items: center;
  }
  .fileInfo2{
    margin-top: 5px;
    flex-wrap: wrap;
    .box1{
      width: 45%;
      margin-top: 10px;
    }
    .box2{
      width: 50%;
    }
  }
  span{
    display: block;
  }
  .green{
    color: green;
  }
  .fileInforight{
    margin-left: 8px;
    flex: 1;
    span{
      color: #333;
    }
    div.box1{
      width: 100%;
      margin-top: 5px;
    }
    div.box2{
      width: 45%;
    }
    div.box3{
      width: 55%;
    }
    
  }
}

</style>

